/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedUsers.defs.js'
export * as $defs from './getSuggestedUsers.defs.js'
